import { render, staticRenderFns } from "./comImage.vue?vue&type=template&id=15e9dea5&scoped=true"
import script from "./comImage.vue?vue&type=script&lang=js"
export * from "./comImage.vue?vue&type=script&lang=js"
import style0 from "./comImage.vue?vue&type=style&index=0&id=15e9dea5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e9dea5",
  null
  
)

export default component.exports